const E = {
  POPUP: "popup",
  MODE: "mode",
  SERVICE: "service",
  LOCATION_ID: "location_id",
  NOW: "now",
  TABLE_ID: "table_id",
  PLACE_ID: "place_id",
  ADDRESS_EXTRA: "address_extra",
  PEOPLE: "people",
  TIMESTAMP: "timestamp"
}, n = new Set(Object.values(E));
function o(t) {
  const e = new URLSearchParams(t);
  return n.forEach((a) => e.delete(a)), e.toString();
}
export {
  E as LANDING_QUERY_PARAMS,
  n as LANDING_QUERY_PARAM_KEYS,
  o as filterLandingParams
};
//# sourceMappingURL=landing-query-params.js.map
